import styled from 'styled-components';
import { media } from '../../../Utils/mediaQueries';

export const LeaderboardConainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0 2% 50px 2%;

    & .infinite-scroll-component {
        display: flex;
        flex-wrap: wrap;

        ${props => {
            if (props.center) {
                return `
                width: 568px;
                justify-content: center;
                `;
            } else {
                return `
                width: 782px;
                @media (max-width: 1118px) {
                    width: 716px;
                }
        
                ${media.tablet`
                    width: 782px;
                `};
        
                ${media.phone`
                    width: 672px;
                `};
        
                @media (max-width: 696px) {
                    width: 100%;
                    flex-direction: column;
                    align-items: center;
                }
                `;
            }
        }};
    }
`;



// WEBPACK FOOTER //
// ./src/UI/Containers/LeaderBoards/style.js